import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Collapse } from "@material-ui/core";

import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import InstallmentPaymentForm from "./InstallmentPaymentForm";

class PaymentForm extends Component {

  render = () => {
    const { step } = this.props;
    return (<>
        <Collapse in={step === 1}>
          <StepOne {...this.props} />
        </Collapse>
        <Collapse in={step === 2}>
          <StepTwo {...this.props} />
        </Collapse>
        <Collapse in={step === 3}>
          <StepThree {...this.props}/>
        </Collapse>
        <Collapse in={step === 4}>
          <InstallmentPaymentForm {...this.props}/>
        </Collapse>
    </>);
  }
}

PaymentForm.propTypes = {
  step: PropTypes.number.isRequired,
};

const mapStateToProps = ({ payment }) => ({
  step: payment.step,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentForm);
